<template>
    <page>
        <module>
            <div class="order-state flex-between-center">
                <h1>{{ title }}</h1>
                <p v-if="step == 1">请选择售后类型及售后服务</p>
                <node-list v-else :nodes="nodeList"></node-list>
            </div>
            <div v-if="step == 1">
                <c-detail title="订单信息">
                    <c-detail-item label="订单号">
                        {{ orderDetail.order_number }}
                    </c-detail-item>
                    <c-detail-item label="订单状态">
                        <span v-if="orderDetail.order_state == 6"
                              style="color:#999">{{ orderStateName[orderDetail.order_state] }}</span>
                        <span v-else-if="orderDetail.check_state==1 || orderDetail.check_state==3">
							<span style="color:#182eff">{{ orderStateName[orderDetail.order_state] }}</span>
						</span>
                        <span v-if="orderDetail.check_state==2">
							<span v-if="orderDetail.refund_flag == 1" style="color: #ff5555">退款中</span>
							<span v-else>
								<span v-if="orderDetail.order_state == 1"
                                      style="color:#182eff">{{ orderStateName[orderDetail.order_state] }}</span>
								<span v-if="orderDetail.order_state == 2"
                                      style="color:#182eff">{{ orderStateName[orderDetail.order_state] }}</span>
								<span v-if="orderDetail.order_state == 3"
                                      style="color:#69d39c">{{ orderStateName[orderDetail.order_state] }}</span>
								<span v-if="orderDetail.order_state == 5"
                                      style="color:darkgreen">{{ orderStateName[orderDetail.order_state] }}</span>
							</span>
							<span v-if="orderDetail.order_state==3 && orderDetail.deliver_state=='部分发货'">(<span
                                style="color:dodgerblue">{{ orderDetail.deliver_state }}</span>)</span>
						</span>
                    </c-detail-item>
                    <c-detail-item label="订单类型">
                        <span v-if="orderDetail.order_type == 1" style="color:#182eff">普通订单</span>
                        <span v-if="orderDetail.order_type == 2" style="color:#182eff">积分兑换订单</span>
                        <span v-if="orderDetail.order_type == 3" style="color:#69d39c">礼包订单</span>
                        <span v-if="orderDetail.order_type == 4" style="color:darkgreen">砍价活动订单</span>
                        <span v-if="orderDetail.order_type == 5" style="color:#182eff">全款预售订单</span>
                        <span v-if="orderDetail.order_type == 6" style="color:#69d39c">定金预售订单</span>
                        <span v-if="orderDetail.order_type == 7" style="color:darkgreen">定制订单</span>
                    </c-detail-item>
                    <c-detail-item label="买家账号">
                        {{ orderDetail.user_manage_mobilephone }}
                        <span v-if="orderDetail.nick_name && orderDetail.nick_name!=''">({{orderDetail.nick_name}})</span>
                    </c-detail-item>
                    <c-detail-item label="下单时间">
                        {{ orderDetail.create_date }}
                    </c-detail-item>
                    <c-detail-item label="付款时间">
                        {{ orderDetail.payment_date }}
                    </c-detail-item>
                </c-detail>
            </div>
            <c-form v-if="step == 1" ref="apply">
                <c-form-item v-model="afterSalesType" name="afterSalesType" type="radio" label="售后类型" :options="afterSalesTypeOption" required></c-form-item>
                <c-form-item label="售后服务">
                    <c-table v-model="productList" height="auto" :paging="false" border>
                        <c-table-column
                            label="服务信息"
                            width="260"
                        >
                            <template v-slot="{data}">
                                <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
                                <product-info v-else :image="data.product_img_url" :name="data.product_name" image-size="60"></product-info>
                            </template>
                        </c-table-column>

                        <c-table-column
                            label="规格名"
                            width="150"
                        >
                            <template v-slot="{data}">
                                {{ data.product_sku_spec }}
                            </template>
                        </c-table-column>

                        <c-table-column
                            label="下单数量"
                            width="60"
                        >
                            <template v-slot="{data}">
                                {{ data.product_count }}
                            </template>
                        </c-table-column>

                        <c-table-column
                            label="单价"
                            width="90"
                        >
                            <template v-slot="{data}">
                                <span v-if="orderDetail.order_type != 2"
                                      style="color:dodgerblue">￥{{ parseFloat(data.product_unit_price).toFixed(2) }}</span>
                                <span v-if="orderDetail.order_type == 2"
                                      style="color:dodgerblue">{{ data.product_unit_price }} 积分</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                            label="已发货数"
                            name="send_count"
                            width="60"
                        >
                            <template v-slot="{data}">
                                <span v-if="data.product_count < data.send_count">{{ data.product_count }}</span>
                                <span v-else>{{ data.send_count }}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                            label="可退数"
                            width="60"
                        >
                            <template v-slot="{data}">
                                <span v-if="afterSalesType == 1">{{ data.can_refund_count }}</span>
                                <span v-if="afterSalesType == 2||afterSalesType == 3">{{ data.can_return_count }}</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                            label="申请数量"
                            width="100"
                        >
                            <template v-slot="{data}">
                                <c-input v-if="afterSalesType == 1" v-model="data.apply_count" width="60" :limit="[0, data.can_refund_count]" type="number"></c-input>
                                <span v-if="afterSalesType == 1">/{{ data.can_refund_count }}</span>
                                <c-input v-if="afterSalesType == 2||afterSalesType == 3" v-model="data.apply_count" width="60" :limit="[0, data.can_return_count]" type="number"></c-input>
                                <span v-if="afterSalesType == 2||afterSalesType == 3">/{{ data.can_return_count }}</span>
                            </template>
                        </c-table-column>
                    </c-table>
                </c-form-item>
            </c-form>

            <div v-if="step == 2" class="order-detail flex">
                <dl class="order-info">
                    <dt class="flex-between-center">
                        <p>订单信息</p>
                    </dt>
                    <dd>
                        <div class="order-info-item flex">
                            <label>订单编号：</label>
                            <p>{{ orderDetail.order_number }}</p>
                        </div>
                        <div class="order-info-item flex">
                            <label>订单状态：</label>
                            <p>
                                <span v-if="orderDetail.order_state == 6"
                                      style="color:#999">{{ orderStateName[orderDetail.order_state] }}</span>
                                <span v-else-if="orderDetail.check_state==1 || orderDetail.check_state==3">
				                <span style="color:#182eff">{{ orderStateName[orderDetail.order_state] }}</span>
				                </span>
                                <span v-if="orderDetail.check_state==2">
				                  <span v-if="orderDetail.refund_flag == 1" style="color: #ff5555">退款中</span>
				                  <span v-else>
				                    <span v-if="orderDetail.order_state == 1"
                                          style="color:#182eff">{{ orderStateName[orderDetail.order_state] }}</span>
				                    <span v-if="orderDetail.order_state == 2"
                                          style="color:#182eff">{{ orderStateName[orderDetail.order_state] }}</span>
				                    <span v-if="orderDetail.order_state == 3"
                                          style="color:#69d39c">{{ orderStateName[orderDetail.order_state] }}</span>
				                    <span v-if="orderDetail.order_state == 5"
                                          style="color:darkgreen">{{ orderStateName[orderDetail.order_state] }}</span>
				                  </span>
				                  <span v-if="orderDetail.order_state==3 && orderDetail.deliver_state=='部分发货'"><br/> (<span
                                      style="color:dodgerblue">{{ orderDetail.deliver_state }}</span>)</span>
				                </span>
                            </p>
                        </div>
                        <div class="order-info-item flex">
                            <label>订单类型：</label>
                            <p>
                                <span v-if="orderDetail.order_type == 1" style="color:#182eff">普通订单</span>
                                <span v-if="orderDetail.order_type == 2" style="color:#182eff">积分兑换订单</span>
                                <span v-if="orderDetail.order_type == 3" style="color:#69d39c">礼包订单</span>
                                <span v-if="orderDetail.order_type == 4" style="color:darkgreen">砍价活动订单</span>
                                <span v-if="orderDetail.order_type == 5" style="color:#182eff">全款预售订单</span>
                                <span v-if="orderDetail.order_type == 6" style="color:#69d39c">定金预售订单</span>
                                <span v-if="orderDetail.order_type == 7" style="color:darkgreen">定制订单</span>
                            </p>
                        </div>
                        <div class="order-info-item flex">
                            <label>买家账号：</label>
                            <p>{{orderDetail.user_manage_mobilephone}}</p>
                            <span v-if="orderDetail.nick_name && orderDetail.nick_name!=''">({{orderDetail.nick_name}})</span>
                        </div>
                        <div class="order-info-item flex">
                            <label>下单时间：</label>
                            <p>{{ orderDetail.create_date }}</p>
                        </div>
                        <div class="order-info-item flex">
                            <label>付款时间：</label>
                            <p>{{ orderDetail.payment_date }}</p>
                        </div>
                    </dd>
                </dl>

                <div class="order-node flex-grow">
                    <h1>提交申请</h1>
                    <div class="order-node-content">
                        <ul class="flex-wrap">
                            <li class="flex full">
                                <label v-if="orderDetail.order_type == 2">退款服务积分：</label>
                                <p v-if="orderDetail.order_type == 2">{{ total.sum }} 积分</p>
                            </li>
                            <template v-if="afterSalesType == 1 && orderDetail.order_type != 2">
                                <li class="flex">
                                    <label><b style="color:red">*</b>退还服务金额：</label>
                                    <p>
                                        <c-input v-model="productMoneySum" type="number" decimal="2" width="80" :limit="[0, productMoneyLimit]" disabled></c-input>
                                    </p>
                                </li>
                                <li v-if="afterSalesType == 1" class="flex">
                                    <label>可退服务金额：</label>
                                    <p>￥{{ productMoneyLimit }}</p>
                                </li>
                            </template>
                            <!-- <template v-if="afterSalesType == 1 && orderDetail.order_type != 2">
                                <li class="flex">
                                    <label><b style="color:red">*</b>退款运费：</label>
                                    <p>
                                        <c-input v-model="logisticsSum" type="number" decimal="2" width="80"
                                                 :limit="[0, logisticsSumLimit]"></c-input>
                                    </p>
                                </li>
                                <li v-if="afterSalesType == 1" class="flex">
                                    <label>可退运费：</label>
                                    <p>￥{{ logisticsSumLimit.toFixed(2) }}</p>
                                </li>
                            </template> -->
                            <template v-if="(afterSalesType == 2||afterSalesType == 3) && orderDetail.order_type != 2">
                                <li v-if="(afterSalesType == 2||afterSalesType == 3)" class="flex">
                                    <label>退还服务金额：</label>
                                    <p style="color:dodgerblue">￥{{ productMoneyLimit }}</p>
                                </li>
                            </template>
                            <li class="flex full">
                                <label><b style="color:red">*</b>申请原因：</label>
                                <textarea class="flex-grow" v-model="remark"></textarea>
                            </li>
                        </ul>
                    </div>
                    <div class="order-total">
                        <span>申请数量：{{ total.num }}件</span>
                        <span v-if="orderDetail.order_type != 2">申请退款金额：<b>￥{{ totalSum }}</b></span>
                        <span v-if="orderDetail.order_type == 2">申请退款积分：<b>{{ totalSum }} 积分</b></span>
                    </div>
                </div>
            </div>

            <template v-if="step == 1" slot="button">
                <c-button size="m" @click="apply()">下一步</c-button>
            </template>
        </module>
        <module v-if="step == 2">
            <div class="order-detail">
                <c-table v-model="applyProductList" height="auto" :paging="false" border>
                    <c-table-column
                        label="服务信息"
                        width="300"
                    >
                        <template v-slot="{data}">
                            <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
                            <product-info v-else :image="data.product_img_url" :name="data.product_name" image-size="60"></product-info>
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="规格名"
                        width="150"
                    >
                        <template v-slot="{data}">
                            {{ data.product_sku_spec }}
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="下单数量"
                        width="60"
                    >
                        <template v-slot="{data}">
                            {{ data.product_count }}
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="单价"
                        width="90"
                    >
                        <template v-slot="{data}">
                            <span v-if="orderDetail.order_type != 2" style="color:dodgerblue">￥{{ parseFloat(data.product_unit_price).toFixed(2) }}</span>
                            <span v-if="orderDetail.order_type == 2" style="color:dodgerblue">{{ data.product_unit_price }} 积分</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="已发货数"
                        name="send_count"
                        width="60"
                    >
                        <template v-slot="{data}">
                            <span v-if="data.product_count < data.send_count">{{ data.product_count }}</span>
                            <span v-else>{{ data.send_count }}</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="申请数量"
                        name="apply_count"
                    ></c-table-column>
                </c-table>
            </div>

            <template slot="button">
                <c-button v-show="step == 2" color="black" hollow size="m" @click="step = 1">上一步</c-button>
                <c-button v-show="step == 2" size="m" @click="apply()">提交申请</c-button>
            </template>
        </module>
        <c-dialog ref="returnFormDialog" title="退货信息" width="700" height="400" @resolve="handleApply">
            <c-form ref="returnForm">
                <c-form-item type="radio" label="退货地址" required :options="returnAddressOption" name="return_address"></c-form-item>
                <c-form-item type="input" label="物流公司" name="return_logistics_company"></c-form-item>
                <c-form-item type="input" label="物流单号" name="return_logistics_number"></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
import nodeList from '@/components/public/node_list.vue'
import productInfo from '@/components/public/product_info.vue'
import {mapState} from 'vuex'

export default {
    name: 'after_sales_apply',

    components: {
        nodeList, productInfo
    },

    props: {
        orderNumber: String
    },

    data() {
        return {
            orderStateName: {
                1: '待付款',
                2: '待发货',
                3: '待收货',
                5: '交易完结',
                6: '已关闭'
            },
            step: 1,
            afterSalesTypeOption: [],
            afterSalesType:0,   //售后类型 1=未发退款  2=已发【仅退款】 3=已发【退货退款】
            productList: [],
            can_refund_product_count: 0,
            can_return_product_count: 0,
            returnType:0,       //退货退款类型 1=需要退货  2=无需退货
            orderDetail: {},
            applyProductList: [],
            logisticsSum: 0,
            logisticsSumLimit: 0,
            productMoneySum: 0,
            productMoneyLimit: 0,
            remark: '',
            returnAddressList: []
        }
    },

    computed: {
        ...mapState(['dict']),

        title() {
            var result = "";
            if (this.step == 1){
                result = "申请售后"
            }else {
                if (this.afterSalesType == 1){
                    result = "未发退款";
                }else if (this.afterSalesType == 2){
                  result = "【已发】仅退款（无需寄回服务）";
                }else if (this.afterSalesType == 3){
                  result = "【已发】退货退款（需要寄回服务）";
                }
            }
            return result;
        },

        nodeList() {
            if (this.afterSalesType == 1) {
                return [{
                    name: '提交申请',
                    current: true
                }, {
                    name: '退款审批'
                }, {
                    name: '退款完结'
                }];
            } else if (this.afterSalesType==3){
                return [{
                    name: '提交申请',
                    current: true
                }, {
                    name: '退货审批'
                }, {
                    name: '买家退货'
                }, {
                    name: '商家收货'
                }, {
                    name: '退款完结'
                }];
            } else if (this.afterSalesType==2){
                return [{
                    name: '提交申请',
                    current: true
                }, {
                    name: '退货审批'
                }, {
                    name: '财务审批'
                }, {
                    name: '退款完结'
                }];
            }
        },

        total() {
            var num = 0, sum = 0;
            this.applyProductList.forEach(item => {
                num += parseInt(item.apply_count);
                sum += item.apply_count * item.product_unit_price;
            });

            return {
                num,
                sum: parseFloat(sum.toFixed(2))
            }
        },

        totalSum() {
            var total_money = 0;
            if (this.afterSalesType == 1) {
                total_money = ((parseFloat(this.logisticsSum) || 0) + (parseFloat(this.productMoneySum) || 0));
            } else {
                total_money = parseFloat(((parseFloat(this.logisticsSum) || 0) + this.total.sum));
            }
            return total_money;
        },

        returnAddressOption() {
            return Array.from(this.returnAddressList, item => {
                return {
                    name: `${item.after_sale_name}，${item.after_sale_mobile}，${item.after_sale_address}`,
                    value: item.id
                }
            });
        }
    },

    watch: {
        orderNumber() {
            this.initOrderReturnable();
            if (this.afterSalesType == 1){//未发退款
                this.getRefunAbleProductList();
            }else {//退货退款
                this.getReturnAbleProductList();
            }
        },

        afterSalesType(val) {
            this.productList = [];
            this.logisticsSumLimit = 0;
            if (val == 1) {//未发退款
                this.getRefunAbleProductList();
            } else {//退货退款
                this.getReturnAbleProductList();
            }
        }
    },

    mounted() {
        this.initOrderReturnable();
    },

    methods: {
        initOrderReturnable() {
            this.request({
                url: '/order/returnable/count',
                data: {
                    order_number: this.orderNumber
                },
                loading: true,
                success: data => {
                  var afterType = 0;
                  this.afterSalesTypeOption = [];
                  this.orderDetail = data.order_info;
                  if (data.can_refund_cont > 0) {
                        this.afterSalesTypeOption.push({
                          name: '未发退款',
                          value: 1
                        });
                        afterType = 1;//未发退款
                  }
                  if (data.can_return_cont > 0) {
                        if (afterType == 0){
                            afterType = 2;//退货退款
                        }
                        this.afterSalesTypeOption.push({
                              name: '【已发】仅退款（无需寄回服务）',
                              value: 2
                        });
                        if (this.orderDetail.order_classify == '1'){
                            this.afterSalesTypeOption.push({
                              name: '【已发】退货退款（需要寄回服务）',
                              value: 3
                            });
                        }
                  }

                  if (this.afterSalesType == 1) {//未发退款
                      this.getRefunAbleProductList();
                  } else {//退货退款
                      this.getReturnAbleProductList();
                  }

                  this.$nextTick(() => {
                      this.$refs.apply.set({
                          afterSalesType: afterType
                      })
                  })
                }
            });
        },
        getRefunAbleProductList() {//加载可以【未发退款】服务列表
            this.request({
                url: '/refund/returnable',
                data: {
                    order_number: this.orderNumber
                },
                loading: true,
                success: data => {
                    this.productList = data.product_list;
                    this.logisticsSumLimit = data.remain_logistics_money;
                }
            });
        },
        getReturnAbleProductList() {//加载可以【退货退款】服务列表
            this.request({
                url: '/returns/returnable',
                data: {
                    order_number: this.orderNumber
                },
                loading: true,
                success: data => {
                    this.productList = data.product_list;
                }
            });
        },
        apply(stop) {
            if (this.step == 1) {
                this.applyProductList = this.productList.filter(item => item.apply_count > 0);
                if (!this.applyProductList.length) {
                    this.$message({
                        text: '请填写要申请售后的服务数量',
						icon: 'fail'
                    });
                    return;
                }
                this.productMoneySum = 0;
                this.applyProductList.forEach(item => {
                    if (item.apply_count > 0) {
                        this.productMoneySum = (parseFloat(this.productMoneySum) + parseFloat(item.apply_count) * parseFloat(item.product_unit_price)).toFixed(2);
                    }
                });
                this.productMoneyLimit = this.productMoneySum;
                this.logisticsSum = 0;
                this.remark = '';
                this.step = 2;
            } else {
                // if (this.afterSalesType == 1 && !this.logisticsSum) {
                //     this.$message({
                //         text: '请填写退款运费'
                //     });
                //     return;
                // }
                if (!this.remark) {
                    this.$message({
                        text: '请填写申请原因',
						icon: 'fail'
                    });
                    return;
                }
                //获取是否需要审批配置
                this.request({
                    url: '/platform_config/info',
                    data: {"code":"RETURN_ORDER_CHECK_ENABLED"},
                    loading: true,
                    success: data => {
                        this._RETURN_ORDER_CHECK_ENABLED = data;

                        if ((this.afterSalesType == 2||this.afterSalesType == 3) && !stop && this._RETURN_ORDER_CHECK_ENABLED == 'OFF') {
                            this.request({
                                url: '/after_sale_address/list',
                                data: {
                                    pageIndex: 1,
                                    pageSize: 20,
                                    state: [2]
                                },
                                loading: true,
                                success: data => {
                                    this.returnAddressList = data;
                                    this.$refs.returnFormDialog.open();
                                }
                            });

                        } else {
                            this.handleApply();
                        }
                    }
                });


            }
        },
        handleApply(stop){
            new Promise(resolve => {
                if (this.afterSalesType == 1 || this._RETURN_ORDER_CHECK_ENABLED == 'ON') {
                    resolve();
                } else {
                    stop();
                    this.$refs.returnForm.submit({
                        local: true,
                        rule: {
                            return_address: [{
                                type: 'empty',
                                word: '请选择退货地址'
                            }]
                        },
                        dataFormatter: data => {
                            let address = this.returnAddressList.find(item => item.id == data.return_address);
                            if (address) {
                                data.return_after_sale_name = address.after_sale_name;
                                data.return_after_sale_mobile = address.after_sale_mobile;
                                data.return_after_sale_address = address.after_sale_address;
                            }
                            delete data.return_address;
                            return data;
                        },
                        success: resolve
                    });
                }
            }).then(data => {
				this.logisticsSum = "0";
                this.request({
                    url: this.afterSalesType == 1 ? '/refund/apply' : '/returns/apply',
                    data: Object.assign({
                        order_number: this.orderNumber,
                        refund_product_money: this.productMoneySum,
                        refund_freight_money: this.logisticsSum,
                        return_type: this.afterSalesType == 2?2:1,   //售后类型  1（需要寄回货物）；2（仅退款，无需寄回货物）
                        [this.afterSalesType == 1 ? 'refund_reason' : 'return_reason']: this.remark,
                        [this.afterSalesType == 1 ? 'refund_sku_list' : 'return_sku_list']: Array.from(this.applyProductList, item => {
                            return {
                                product_sku: item.product_sku,
                                product_count: parseInt(item.apply_count),
                                voucher_img_url: item.voucher
                            }
                        })
                    }, data || {}),
                    loading: true,
                    success: data => {
                        //刷新列表
                        this.$bus.$emit('return.update', {});

                        this.$refs.returnFormDialog.close();
                        this.$message({
                            text: '申请成功',
							icon: 'success'
                        });
                        this.redirectTo(`${this.afterSalesType == 1 ? 'refund_detail' : 'return_detail'}/${data}`);
                    }
                });
            });
        },
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/style/theme'

.order {
    &-state {
        height: 120px;
        padding: 0 34px;
        color: #fff;
        background: #622F8A;
        background-image: url('~@/assets/image/order_detail_state_bg.png');
        background-size: 100% auto;
        background-position: left bottom;
        background-repeat: no-repeat;

        h1 {
            font-size: 24px;
        }

        p {
            font-size: 13px;
            margin-top: 15px;
        }
    }

    &-detail {
        padding: 30px;
    }

    &-info {
        width: 38%;
        border: 1px solid #ddd;

        dt {
            height: 42px;
            border-bottom: 1px solid #ddd;
            padding: 0 12px 0 16px;

            p {
                font-size: 13px;
                font-weight: bold;
            }
        }

        dd {
            padding: 12px 25px 12px 18px;
        }

        &-item {
            padding: 6px 0;
            line-height: 20px;
            font-size: 12px;

            label {
                min-width: 5em;
                color: #666;
                text-align: right;
            }

            p {
                a {
                    color: #003DD9;
                }
            }
        }
    }

    &-node {
        border: 1px solid #ddd;
        border-left: none;
        padding: 0 20px;

        h1 {
            line-height: 90px;
            font-size: 24px;
            font-weight: normal;
            text-align: center;
        }

        &-content {
            padding: 30px 0 40px 14%;
            background: #FAFAFA;

            li {
                box-sizing: border-box;
                width: 50%;
                padding: 8px 20px 8px 0;
                line-height: 20px;
                font-size: 13px;

                &.full {
                    width: 100%;
                }

                label {
                    min-width: 7em;
                    line-height: 30px;
                    color: #666;
                    text-align: right;
                }

                p {
                    line-height: 30px;

                    a {
                        color: #003DD9;
                    }
                }

                textarea {
                    height: 40px;
                    border: 1px solid #ddd;
                    padding: 8px;
                    line-height: 20px;
                    resize: none;
                }
            }
        }
    }

    &-total {
        padding: 16px 0;
        font-size: 13px;
        text-align: right;

        span {
            margin-left: 2em;
        }

        b {
        theme-color(main);
        }
    }
}

.product {
    &-info {
        margin-left: 18px;
        line-height: 24px;
        font-size: 12px;
        color: #444;
    }
}
</style>